/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
import "tailwindcss/tailwind.css";
import { createApp } from "vue";

window.Vue = require("vue").default;

// import Vue from "vue";

const moment = require("moment");
require("moment/locale/nl");

// Vue.use(require("vue-moment"), {
//     moment,
// });

import { createI18n } from "vue-i18n";
import Locale from "./vue-i18n-locales.generated";
const lang = document.documentElement.lang.substr(0, 2);

const i18n = createI18n({
    locale: lang,
    messages: Locale,
});

window.Vapor = require("laravel-vapor");

import TinyEmitter from "tiny-emitter";

// Vue.directive("mask", VueMaskDirective);

window.Eventing = new (class {
    constructor() {
        this.emitter = new TinyEmitter();
    }
    fire(event, data = null, subdata = null) {
        this.emitter.emit(event, data, subdata);
    }
    listen(event, callback) {
        this.emitter.on(event, callback);
    }
})();

// import VueRouter from "vue-router";
const VueRouter = require("vue-router");
// import VueRouter from "vue-state-router";

// Vue.use(VueRouter);

// // 1. Define route components.
// // These can be imported from other files
// const Home = { template: "<div>Home</div>" };
// const About = { template: "<div>About</div>" };

// // 2. Define some routes
// // Each route should map to a component.
// // We'll talk about nested routes later.
// const routes = [
//     { path: "/", component: Home },
//     { path: "/about", component: About },
// ];

import Home from "./views/Hello.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/app",
        name: "app-home",
        component: require("./views/Dashboard.vue").default,
    },
    {
        path: "/hello",
        name: "hello",
        component: require("./views/Hello.vue").default,
    },
    {
        path: "/proxyvoting",
        name: "proxyvoting",
        component: require("./proxy-voting/Transfer.vue").default,
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: require("./views/Dashboard.vue").default,
    },
    {
        path: "/meeting/:slug",
        name: "room",
        component: require("./views/Room.vue").default,
    },
    {
        path: "/backstage",
        name: "backstage",
        component: require("./views/Backstage.vue").default,
    },
    {
        path: "/login/:code?",
        name: "login",
        component: require("./views/Login.vue").default,
    },
    {
        path: "/login-qr",
        name: "login-qr",
        component: require("./views/Login.vue").default,
    },
    {
        path: "/live/:slug",
        name: "live",
        component: require("./views/LiveRoom.vue").default,
    },
    {
        path: "/access",
        name: "access",
        component: require("./views/Access.vue").default,
    },
    {
        path: "/modules",
        name: "modules",
        component: require("./views/Modules.vue").default,
        children: [
            {
                path: "mailings",
                name: "mailings",
                components: {
                    // default: UserProfile,
                    details: require("./views/Modules/Mailings.vue").default,
                },
                children: [
                    {
                        path: "index",
                        name: "mailings-index",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            // .default,
                            tab: require("./views/Modules/Mailings/Index.vue")
                                .default,
                        },
                    },
                    {
                        path: "history",
                        name: "mailings-history",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Modules/Mailings/History.vue")
                                .default,
                        },
                    },
                    {
                        path: "create",
                        name: "mailings-create",

                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Modules/Mailings/Index.vue")
                                .default,
                            formtab:
                                require("./views/Modules/Mailings/Create.vue")
                                    .default,
                        },
                    },
                    {
                        path: "edit/:id",
                        name: "mailings-edit",
                        components: {
                            tab: require("./views/Modules/Mailings/Index.vue")
                                .default,
                            formtab:
                                require("./views/Modules/Mailings/Edit.vue")
                                    .default,
                            // modal: require("./views/Modules/Mailings/Edit.vue").default,
                        },
                    },
                    {
                        path: "upload",
                        name: "mailings-upload",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Modules/Mailings/Upload.vue")
                                .default,
                        },
                    },
                ],
            },
        ],
    },

    {
        path: "/m",
        name: "module-members",
        component: require("./views/Modules/Members/App.vue").default,
        children: [
            {
                path: "members",
                name: "members",
                components: {
                    // default: UserProfile,
                    details: require("./views/Modules/Members.vue").default,
                },
                children: [
                    {
                        path: "create",
                        name: "members-create",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Modules/Members/Create.vue")
                                .default,
                        },
                    },
                    {
                        path: "edit/:id",
                        name: "members-edit",
                        components: {
                            // default: require("./views/Modules/Members/Edit.vue")
                            //     .default,
                            tab: require("./views/Modules/Members/Edit.vue")
                                .default,
                            // modal: require("./views/Modules/Members/Edit.vue")
                            //     .default,
                        },
                    },
                    {
                        path: "upload",
                        name: "members-upload",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Modules/Members/Upload.vue")
                                .default,
                        },
                    },
                ],
            },
        ],
    },
    {
        path: "/settings",
        name: "settings",
        component: require("./views/Settings.vue").default,
        children: [
            {
                path: "meetings",
                name: "meetings",
                components: {
                    details: require("./views/Settings/Meetings.vue").default,
                },
                children: [
                    {
                        path: "index",
                        name: "meetings-index",
                        components: {
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                        },
                    },
                    {
                        path: "history",
                        name: "meetings-history",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/History.vue")
                                .default,
                        },
                    },
                    {
                        path: "create",
                        name: "meetings-create",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                            modal: require("./views/Settings/Meetings/Create.vue")
                                .default,
                        },
                    },
                    {
                        path: "edit/:id",
                        name: "meetings-edit",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                            modal: require("./views/Settings/Meetings/Edit.vue")
                                .default,
                        },
                    },
                    {
                        path: "polls/:id",
                        name: "meetings-polls",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                            modal: require("./views/Settings/Meetings/Polls.vue")
                                .default,
                        },
                    },
                    {
                        path: "poll-concepts/:id",
                        name: "meetings-poll-concepts",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                            modal: require("./views/Settings/Meetings/PollConcepts.vue")
                                .default,
                        },
                    },
                    {
                        path: "documents/:id",
                        name: "meetings-documents",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Meetings/Index.vue")
                                .default,
                            modal: require("./views/Settings/Meetings/Documents.vue")
                                .default,
                        },
                    },
                ],
            },
            {
                path: "profile",
                name: "profile",
                components: {
                    // default: UserProfile,
                    details: require("./views/Settings/Profile.vue").default,
                },
                children: [
                    {
                        path: "index",
                        name: "profile-index",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            // .default,
                            tab: require("./views/Settings/Profile/Index.vue")
                                .default,
                        },
                    },
                    {
                        path: "edit",
                        name: "profile-edit",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Profile/Index.vue")
                                .default,
                            modal: require("./views/Settings/Profile/Edit.vue")
                                .default,
                        },
                    },
                ],
            },
            {
                path: "attendees",
                name: "attendees",
                components: {
                    // default: UserProfile,
                    details: require("./views/Settings/Attendees.vue").default,
                },
                children: [
                    {
                        path: "index",
                        name: "attendees-index",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            // .default,
                            tab: require("./views/Settings/Attendees/Index.vue")
                                .default,
                        },
                    },
                    {
                        path: "inactive",
                        name: "attendees-inactive",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Attendees/Inactive.vue")
                                .default,
                        },
                    },
                    {
                        path: "create",
                        name: "attendees-create",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Attendees/Index.vue")
                                .default,
                            modal: require("./views/Settings/Attendees/Create.vue")
                                .default,
                        },
                    },
                    {
                        path: "edit/:id",
                        name: "attendees-edit",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Attendees/Index.vue")
                                .default,
                            modal: require("./views/Settings/Attendees/Edit.vue")
                                .default,
                        },
                    },
                    {
                        path: "upload",
                        name: "attendees-upload",
                        components: {
                            // default: require("./views/Settings/Meetings.vue")
                            //     .default,
                            tab: require("./views/Settings/Attendees/Upload.vue")
                                .default,
                        },
                    },
                ],
            },
        ],
    },
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = VueRouter.createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: VueRouter.createWebHashHistory(),
    routes, // short for `routes: routes`
    // linkExactActiveClass: "",
});

// const app = new Vue.createApp({
//     el: "#app",
//     // i18n,
//     components: { App },
//     router,
// });

import axios from "axios";
import Maska from "maska";
import VueChatScroll from "./plugins/chat-scroll";

// const app = createApp({ i18n });
const app = createApp({});
app.config.globalProperties.t = (key, fallback, replace, replace_2) => {
    const i18nKey = key.startsWith("tts.") ? key : "tts." + key;
    let txt = i18n.global.t(i18nKey);
    if (txt === i18nKey && fallback) {
        txt = fallback;
    }
    if (replace !== undefined && replace !== null) {
        txt = txt.replace(":value", replace);
    }
    if (replace_2 !== undefined && replace_2 !== null) {
        txt = txt.replace(":value_2", replace_2);
    }
    return txt;
};

import VueTheMask from "vue-the-mask";

app.use(router);

app.use(i18n);
app.use(VueTheMask);
app.use(Maska);
app.use(VueChatScroll);
app.directive("maska", Maska.maska);

// v-uppercase
app.directive("uppercase", {
    update(el) {
        el.value = el.value.toUpperCase();
    },
});

app.component("onlinealv", require("./views/App.vue").default);
app.component("request-login", require("./views/Login.vue").default);

app.component("logo-nl", require("./logos/online-alv.nl.svg.vue").default);
app.component("icon-loader", require("./icons/loader.vue").default);

app.component("sidebar", require("./components/Sidebar.vue").default);
app.component("chatbox", require("./components/Chatbox.vue").default);
app.component("polls", require("./components/Polls.vue").default);
app.component("attendees", require("./components/Attendees.vue").default);
app.component("documents", require("./components/Documents.vue").default);

app.component("my-profile", require("./modals/MyProfile.vue").default);

app.component("menubar", require("./components/Menubar.vue").default);

app.component("users", require("./components/Users.vue").default);
app.component("user", require("./components/User.vue").default);
app.component("user-options", require("./components/UserOptions.vue").default);

app.component(
    "members-table",
    require("./views/Modules/Members/SidebarTable.vue").default,
);

app.component(
    "form-member",
    require("./views/Modules/Members/Form.vue").default,
);
app.component("roles", require("./views/Modules/Members/Roles.vue").default);

app.component("meetings", require("./components/Meetings.vue").default);
app.component("meeting", require("./components/Meeting.vue").default);

app.component("ivs-embed", require("./stream/IVS.vue").default);

app.component(
    "attendee-stats",
    require("./components/AttendeeStats.vue").default,
);

app.component("form-user", require("./forms/User.vue").default);
app.component("form-organisation", require("./forms/Organisation.vue").default);
app.component("form-meeting", require("./forms/Meeting.vue").default);

app.component(
    "users-actions",
    require("./components/UsersActions.vue").default,
);

app.component("session", require("./stream/Session.vue").default);

app.component(
    "vonage-controller",
    require("./stream/VonageController.vue").default,
);

app.component("new-poll", require("./modals/PollCreate.vue").default);
app.component("poll", require("./modals/Poll.vue").default);

app.component("proxy-voting-poll", require("./proxy-voting/Poll.vue").default);

// Modules
app.component("mailings", require("./components/modules/Mailings.vue").default);
app.component("mailing", require("./components/modules/Mailing.vue").default);
app.component("form-mailing", require("./forms/Modules/Mailing.vue").default);

app.mount("#app");
